import fetch from '@/utils/fetch.js'
import {shop_url} from '@/global';
//企业管理接口
export   function getComAll(companyName,end,page,rows,start){
    let url=`${shop_url}/shop/cms/company`
    const method = 'post';
    const data={companyName,end,page,rows,start}
    return fetch({
        url: url,
        method,
        data
    })
}

//增加企业
export   function  AddCompany(name,phone,address,description,logo){
    let data={name,phone,address,description,logo}
    let url=`${shop_url}/shop/cms/company`
    const method = 'put';
    return fetch({
        url: url,
        method,
        data
    })
}
//删除企业 id:企业id,type:1激活，2封号，3删除
export function delCompany(id,type) {
    let data={id,type}
    let url=`${shop_url}/shop/cms/company/active`
    const method = 'put';
    return fetch({
        url: url,
        method,
        data
    })
  }
  //编辑企业
  export function compile(id) {
    let url=`${shop_url}/shop/cms/company/`+id
    return fetch({
        url: url
    })
  }
  //修改企业
  export   function  UpdateCompany(id,name,phone,address,description,logo){
    let data={id,name,phone,address,description,logo}
    let url=`${shop_url}/shop/cms/company/info`
    const method = 'put';
    return fetch({
        url: url,
        method,
        data
    })
}

const getUploadToken = () => {
    return fetch({
        url: `${shop_url}/shop/shop/category/auth`,
        method: "get"
    })
}

const getUploadId = (data, number) => {
    return fetch({
        url: `${shop_url}/shop/shop/category/getId?num=${number}`,
        method: "get"
    })
}
export {
    getUploadToken,
    getUploadId
}



// WEBPACK FOOTER //
// ./src/api/companyApi/company.js